import Link from 'next/link';
import React, {ReactNode} from 'react';


type ButtonProps = {    
  disabled?: boolean,
  children: ReactNode;
  className?: string;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  ariaLabel?: string;
  isLink?: boolean;
  href?: string;
};


const ButtonFill = ({ children, className, disabled, onClick, ariaLabel = '', isLink = false, href = '/'}: ButtonProps) => {
    return (
        <>
            {isLink ? <Link href={href} aria-label={ariaLabel}  className={`${disabled ? 'opacity-40' : 'hover:border-transparent-anim hover:bg-dusty-pink-light cursor-pointer'} border-[1px] border-dusty-blue  bg-transparent-anim  transition-colors duration-300 w-full flex px-[3.2rem] py-[1.4rem] text-dark-blue items-center justify-center text-btn-big ${className || ""}`}>{children}</Link> : 
            <button disabled={disabled} aria-label={ariaLabel} onClick={onClick} className={`${disabled ? 'opacity-40' : 'hover:border-transparent-anim hover:bg-dusty-pink-light cursor-pointer'} border-[1px] border-dusty-blue  bg-transparent-anim  transition-colors duration-300 w-full flex px-[3.2rem] py-[1.4rem] text-dark-blue items-center justify-center text-btn-big ${className || ""}`}>
                {children}
            </button>}

        </>

    );
};

export default ButtonFill;